import { AngularEditorComponent, AngularEditorConfig } from '@kolkov/angular-editor';
import { EmailEvent, EmailEventsService, EmailParameterResponse, Event, SendEmailEventData } from '../../../Services/email-events.service';
import { Component, ElementRef, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { AuthService, EmailEventsFilters } from 'src/app/Services/auth.service';
import { NotificationsService } from 'src/app/Services/shared/notifications.service';
import { NotificationTypes } from 'src/app/app.enums';
import { copyToClipboard } from 'src/app/app.functions';
import { ArtFlowSelectItem } from 'src/app/models/artflow.selectitem';
import { EmailEventTypeService } from 'src/app/Services/email-event-type.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Events, Parameters, SaveTemplates, Templates } from 'src/app/models/emailevents.model';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'email-settings',
    templateUrl: './email-settings.component.html',
    styleUrls: ['./email-settings.component.css'],
    providers: [EmailEventsService],
    standalone: false
})
export class EmailSettingsComponent implements OnInit, OnDestroy {
  public loading: boolean = true;
  @ViewChild('emailEditor') emailEditor!: AngularEditorComponent;
  // public emailEvents: ArtFlowSelectItem[] = [];
  public emailEvents: Events[] = [];
  public selectedEmailEvent?: ArtFlowSelectItem;

  // public selectedEmailTemplate!: EmailEvent;
  public selectedEmailTemplate: SaveTemplates = {
    Guid: '',
    HtmlText: '',
    EmailEventId: '',
    Subject: ''
  };
  public isPredefined: boolean = false;
  public emailParametersForAddEvents: SelectItem[] = [];
  public emailParameters: Parameters[] = [];
  public testEmailAddress: string = '';
  public selectedEmailParameter: string | null = null;
  public selectedEmailParameterId!: string;
  public EmailParameterData: EmailParameterResponse = {} as EmailParameterResponse;
  public isEditorInVisualMode: boolean = true;
  public displayEditDialog: boolean = false;
  public emailPreviewVisible: boolean = false;
  public isAddEmailEventDailogVisible: boolean = false
  public isEditMode: boolean = false;
  // public allemailEvents: Event[] = []; // Use correct type
  public allemailEvents: Templates[] = [];
  public emailEventsFormData!: Events;
  public editorConfig: AngularEditorConfig = {
    outline: true,
    rawPaste: true,
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '250px',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    sanitize: false,
    toolbarPosition: 'top',
  };

  public ngOnInit(): void {
    this.fetchAllEvents();
    // this.getSystemEmailEvents();
  }
  constructor(
    private confirmationService: ConfirmationService,
    private authService: AuthService,
    private ngxSpinnerService: NgxSpinnerService,
    private notificationsService: NotificationsService,
    private emailEventsService: EmailEventsService,
    private emailEventTypeService: EmailEventTypeService,
    private router: Router,
    private route: ActivatedRoute,
    private transloco: TranslocoService) {
    // this.selectedEmailTemplate = new EmailEvent();
    this.selectedEmailTemplate = new SaveTemplates();
    this.emailEventsFormData = new Events();
  }

  public onEmailEventChanged($event: any) {
    console.log($event);
    var eventId = $event.value;
    // this.getEmailTemplate(eventId);
    this.getEmailTemplateParameters(eventId);
  }

  public onEmailEditorValueChanged(event: any): void {
    this.selectedEmailTemplate.HtmlText = event.value;
  }

  public onEmailParameterChanged($event: any) {
    this.selectedEmailParameterId = $event.value;
    console.log("selectedEmailParameterId", this.selectedEmailParameterId)
    const emailparameter = this.emailParameters.find((p) => p.Guid === $event.value);
    this.EmailParameterData.ParameterUsage = emailparameter?.ParameterUsage || ''
    this.EmailParameterData.ParameterDescription = emailparameter?.ParameterDescription || ''
    console.log(this.EmailParameterData)
  }



  public saveEmailParameterField($event: any) {
    this.EmailParameterData.Guid = this.selectedEmailParameterId;
    this.ngxSpinnerService.show();
    this.emailEventTypeService.saveEmailParameterData(this.EmailParameterData).subscribe(
      (response) => {
        this.ngxSpinnerService.hide();
        if (response.Success) {
          this.notificationsService.showNotification(this.transloco.translate('emailSettings.success'), response.ResponseMessage, NotificationTypes.Success);
        } else {
          console.error(response);
          this.notificationsService.showNotification(this.transloco.translate('emailSettings.error'), response.ResponseMessage, NotificationTypes.Error);
        }
      }, (error) => { console.error(error); this.ngxSpinnerService.hide(); });
    console.log(this.EmailParameterData);
  }

  private pasteListenerAdded = false;

  public focusEditor($event: any) {
    $event.preventDefault();

    if (!this.pasteListenerAdded && window.addEventListener) {
      window.addEventListener('paste', ($event: any) => {
        $event.preventDefault();

        try {
          const text = $event.clipboardData.getData("text/plain");
          if (text) {
            var editableElement: HTMLElement | null = null;
            if (this.isEditorInVisualMode) {
              editableElement = document.getElementsByClassName('angular-editor-textarea')[0] as HTMLElement;
            } else {
              editableElement = document.getElementById('sourceText');
            }

            if (editableElement) {
              var range = document.createRange();
              var textNode = document.createTextNode(text);
              editableElement.innerHTML = '';
              editableElement.appendChild(textNode);
              range.selectNodeContents(textNode);
              editableElement.appendChild(range.createContextualFragment(text));
            }
          }

        } catch (e) { console.error(e); }
      });
      this.pasteListenerAdded = true;
    }
  }

  public onViewModeChanged($event: boolean) {
    this.isEditorInVisualMode = $event;
  }

  public copySelectedEmailParameter($event: any) {
    const selectedParameter = this.emailParameters.find(param => param.Guid === this.selectedEmailParameter);
    if (selectedParameter && selectedParameter.ParameterName) {
      var appendCurlyBrackets = `{{${selectedParameter.ParameterName}}}`;
      copyToClipboard(appendCurlyBrackets);
      this.notificationsService.showNotification(this.transloco.translate('emailSettings.success'), this.transloco.translate('emailSettings.parameterCopied'), NotificationTypes.Success);
    }
  }

  public insertEmailParameter($event: any) {
    const editorElement = this.emailEditor.textArea.nativeElement;
    const cursorPosition = this.getCursorPosition(editorElement);
    if (cursorPosition > -1) {
      const selectedParameter = this.emailParameters.find(param => param.Guid === this.selectedEmailParameter);
      this.insertTextAtCursorPosition(cursorPosition, selectedParameter?.ParameterName);
    }
  }

  private getCursorPosition(editorElement: HTMLTextAreaElement): number {
    const selection = window.getSelection();
    if (selection && selection.rangeCount > 0) {
      const range = selection.getRangeAt(0);
      const preSelectionRange = range.cloneRange();
      preSelectionRange.selectNodeContents(editorElement);
      preSelectionRange.setEnd(range.startContainer, range.startOffset);
      const start = preSelectionRange.toString().length;
      return start + range.toString().length;
    }
    return -1;
  }

  private insertTextAtCursorPosition(cursorPosition: number, parameterText: string | undefined): void {
    var currentValue = this.selectedEmailTemplate.HtmlText?.replace(/&nbsp;/g, ' ');
    const newValue = (currentValue ? currentValue.substring(0, cursorPosition) : '') + '{{' + parameterText + '}}' + (currentValue ? currentValue.substring(cursorPosition) : '');
    this.selectedEmailTemplate.HtmlText = newValue.replace(/&nbsp;/g, ' ');
    this.selectedEmailParameter = null;
  }



  public fetchAllEvents() {
    this.loading = true;
    this.ngxSpinnerService.show();
    this.emailEventsService.fetchAllTemplates().subscribe(
      (allemailEvents: Templates[]) => {
        this.allemailEvents = allemailEvents;
        console.log(this.allemailEvents, 'emailEvents');
        this.ngxSpinnerService.hide();
        this.loading = false;
      },
      (error) => {
        console.error('Error fetching email events:', error);
        this.ngxSpinnerService.hide();
        this.loading = false;
      }
    );
  }

  public loadedEmailTemplateParameters: boolean = false;
  private getEmailTemplateParameters(eventId: string) {

    this.loadedEmailTemplateParameters = false;
    this.emailEventTypeService.fetchEmailParameters(eventId).subscribe((emailEvents: Parameters[]) => {
      this.emailParameters = emailEvents;
      console.log(this.emailParameters)
      this.loadedEmailTemplateParameters = true;
    }, (error) => { console.error(error); });
  }

  private getEmailTemplate(eventId: string) {
    this.ngxSpinnerService.show();
    this.emailEventsService.getEmailTemplate(eventId).subscribe(
      (emailTemplate: SaveTemplates) => {
        console.log("emailTemplate", emailTemplate)
        if (!emailTemplate) {
          emailTemplate = new SaveTemplates();
          emailTemplate.EmailEventId = eventId;
        }
        this.selectedEmailTemplate = emailTemplate;
        // const foundParameter = this.emailParameters.find((p)=>p.Guid === emailTemplate.EmailEventId)
        // console.log("foundParameter",foundParameter)
        // this.selectedEmailParameter = foundParameter ? foundParameter.Guid : null;
        // console.log("this.selectedEmailParameter",this.selectedEmailParameter)
        this.ngxSpinnerService.hide();
      },
      (error) => {
        console.error(error);
        this.ngxSpinnerService.hide();
      }
    );
  }

  public saveEmailTemplate($event: any) {
    if (this.selectedEmailTemplate.HtmlText) {
      this.selectedEmailTemplate.HtmlText = this.selectedEmailTemplate.HtmlText?.replace(/&nbsp;/g, ' ');
    }
    this.selectedEmailTemplate.Guid = this.selectedEmailParameterId
    console.log(this.selectedEmailTemplate)
    this.ngxSpinnerService.show();
    this.emailEventsService.saveEmailEvents(this.selectedEmailTemplate).subscribe(
      (response) => {
        this.ngxSpinnerService.hide();
        if (response.Success) {
          this.notificationsService.showNotification(this.transloco.translate('emailSettings.success'), response.ResponseMessage, NotificationTypes.Success);
          if (this.displayDialog == true) {
            this.onCloseCreateDialog();
          } else {
            this.onCloseEditDailog();
          }
          this.fetchAllEvents();
        } else {
          console.error(response);
          this.notificationsService.showNotification(this.transloco.translate('emailSettings.error'), response.ResponseMessage, NotificationTypes.Error);
        }
      }, (error) => { console.error(error); this.ngxSpinnerService.hide(); });
  }

  public sendTestEmail($event: any) {
    const testData: SendEmailEventData = {
      SendTo: this.testEmailAddress,
      Subject: this.selectedEmailTemplate.Subject,
      HtmlContent: this.selectedEmailTemplate.HtmlText
    };

    this.emailEventsService.sendTestEmail(testData).subscribe(
      (response) => {
        this.ngxSpinnerService.hide();
        if (response.Success) {
          this.testEmailAddress = '';
          this.notificationsService.showNotification(
            this.transloco.translate('emailSettings.success'),
            response.ResponseMessage,
            NotificationTypes.Success
          );
        } else {
          this.notificationsService.showNotification(
            this.transloco.translate('emailSettings.error'),
            response.ResponseMessage,
            NotificationTypes.Error
          );
        }
      },
      (error) => {
        console.error(error);
        this.ngxSpinnerService.hide();
      }
    );
  }

  public showEditDialog(event: Templates) {
    this.isPredefined = event.EventTypeViewModel.IsPredefined
    console.log(event)
    this.getEmailTemplate(event.Id);
    if (event.EmailEventId) {
      this.ngxSpinnerService.show();
      this.emailEventTypeService.fetchEmailevents(EmailEventsFilters.All).subscribe((emailEvents: Events[]) => {
        this.emailEvents = emailEvents.map(event => ({
          Id: event.Id,
          Name: event.Name,
          Description: event.Description,
          IsPredefined: event.IsPredefined,
          CreatedDate: event.CreatedDate,
          EmailParameterIds: event.EmailParameterIds,
          label: event.IsPredefined ? `${event.Name} (system)` : event.Name,
          value: event.Id,
        }));
        console.log(this.emailEvents, 'emailEvents');
        this.ngxSpinnerService.hide();
      }, (error) => { console.error(error); this.ngxSpinnerService.hide(); });
      this.getEmailTemplateParameters(event.EmailEventId);
      this.isEditMode = true
      this.displayDialog = true;

    }
  }

  public onCloseEditDailog() {
    this.displayEditDialog = false
    this.selectedEmailTemplate = new SaveTemplates();
  }

  public ngOnDestroy(): void { }
  displayDialog: boolean = false;
  templateData = {
    templateName: '',
    parameters: ''
  };

  parameters = [
    { label: 'Parameter 1', value: 'param1' },
    { label: 'Parameter 2', value: 'param2' },
    { label: 'Parameter 3', value: 'param3' }
  ];

  public fetchEmailEvents() {
    this.ngxSpinnerService.show();
    this.emailEventTypeService.fetchEmailevents(EmailEventsFilters.UserDefined).subscribe((emailEvents: Events[]) => {
      this.emailEvents = emailEvents.map(event => ({
        Id: event.Id,
        Name: event.Name,
        Description: event.Description,
        IsPredefined: event.IsPredefined,
        CreatedDate: event.CreatedDate,
        EmailParameterIds: event.EmailParameterIds,
        label: event.Name,
        value: event.Id
      }));
      console.log(this.emailEvents, 'emailEvents');
      this.ngxSpinnerService.hide();
    }, (error) => { console.error(error); this.ngxSpinnerService.hide(); });
  }

  public getEmailParameters() {
    this.emailEventTypeService.fetchEmailParameters().subscribe((emailParameters) => {
      this.emailParametersForAddEvents = emailParameters.map((item) => {
        return { label: item.ParameterName, value: item.Guid };
      });
      console.log('emailParameters: ', this.emailParameters);
    }, (error) => { console.error(error); });
  }
  public openDialog() {
    this.isEditMode = false; // Ensure Add mode
    this.selectedEmailTemplate = new SaveTemplates(); // Reset to a fresh template
    this.emailParameters = []; // Clear parameters to avoid stale data
    this.displayDialog = true;
    this.fetchEmailEvents();
  }

  public onAddEmailEvents() {
    this.isAddEmailEventDailogVisible = true
    this.getEmailParameters();
  }

  public onCloseEmailEventsDialog($event: boolean) {
    this.emailEventsFormData = new Events();
    // this.selectedEmailParameters = []
    this.isAddEmailEventDailogVisible = $event
  }

  public onCloseCreateDialog() {
    this.displayDialog = false;
    this.selectedEmailTemplate = new SaveTemplates();
  }

  public onCloseEmailTemplateDialog($event: boolean) {
    this.isEditMode = false;
    this.selectedEmailTemplate = new SaveTemplates();
    this.displayDialog = $event
  }

  saveTemplate() {
    console.log('Saved Template:', this.templateData);
    // this.closeDialog();
  }

  public onDeleteEmailTemplate(id: string) {
    const emailEventTemplate = this.allemailEvents.find((emailEventTemplate) => emailEventTemplate.Id === id)
    this.confirmationService.confirm({
      message: this.transloco.translate('emailSettings.confirmDeleteTemplate', { name: emailEventTemplate?.EventTypeViewModel.Name }),
      accept: () => {
        this.ngxSpinnerService.show();
        this.emailEventsService.deleteEmailTemplate(id).subscribe((response) => {
          if (response.Success) {
            this.ngxSpinnerService.hide();
            this.notificationsService.showNotification(this.transloco.translate('emailSettings.success'), response.ResponseMessage, NotificationTypes.Success);
            var index = this.allemailEvents.findIndex((emailEventTemplate) => emailEventTemplate.Id == id);
            if (index >= 0) {
              this.emailEvents.splice(index, 1);
              this.fetchAllEvents();
            }
          } else {
            this.ngxSpinnerService.hide();
            this.notificationsService.showNotification(this.transloco.translate('emailSettings.error'), response.ResponseMessage, NotificationTypes.Error);
          }
        }, (error) => { console.error(error); this.ngxSpinnerService.hide(); });
      },
    });
  }

  public showEmailLogDailog() {
    this.emailPreviewVisible = true
  }
}